var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useReducer, useRef } from 'react';
export var UndoTimerActions;
(function (UndoTimerActions) {
    UndoTimerActions[UndoTimerActions["REDUCE_TIMER"] = 0] = "REDUCE_TIMER";
    UndoTimerActions[UndoTimerActions["SET_TIMER"] = 1] = "SET_TIMER";
})(UndoTimerActions || (UndoTimerActions = {}));
var initialState = {
    secondsUntilExpiration: 0,
    canUndo: true,
};
var UndoTimerContext = React.createContext({
    state: initialState,
    dispatch: function () { return null; },
});
export var UndoTimerProvider = function (_a) {
    var children = _a.children, note = _a.note;
    var timerRef = useRef();
    var _b = useReducer(function (state, action) {
        switch (action.type) {
            case UndoTimerActions.REDUCE_TIMER: {
                var newSecondsUntilExpiration = state.secondsUntilExpiration - 1;
                if (newSecondsUntilExpiration <= 0 && timerRef.current) {
                    clearTimeout(timerRef.current);
                    timerRef.current = undefined;
                }
                return __assign(__assign({}, state), { secondsUntilExpiration: newSecondsUntilExpiration >= 0 ? newSecondsUntilExpiration : 0, canUndo: newSecondsUntilExpiration > 0 });
            }
            case UndoTimerActions.SET_TIMER: {
                return __assign(__assign({}, state), { secondsUntilExpiration: action.payload, canUndo: action.payload >= 0 });
            }
            default:
                throw new Error('Invalid action');
        }
    }, initialState), state = _b[0], dispatch = _b[1];
    useEffect(function () {
        if (note === null || note === void 0 ? void 0 : note.signedAt) {
            var signedAtDate = new Date(note.signedAt);
            signedAtDate.setTime(signedAtDate.getTime() + 60 * 60 * 1000); // Add an hour to signed at
            var timeUntilDeadline = signedAtDate.getTime() - new Date().getTime();
            dispatch({
                type: UndoTimerActions.SET_TIMER,
                payload: Math.round(timeUntilDeadline / 1000),
            });
            timerRef.current = setInterval(function () { return dispatch({ type: UndoTimerActions.REDUCE_TIMER }); }, 1000);
        }
        return function () {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = undefined;
            }
        };
    }, [note === null || note === void 0 ? void 0 : note.signedAt]);
    return (_jsx(UndoTimerContext.Provider, __assign({ value: { state: state, dispatch: dispatch } }, { children: children })));
};
export var useUndoTimerContext = function () {
    var context = React.useContext(UndoTimerContext);
    if (context === undefined) {
        throw new Error('useUndoTimerContext must be used within a UndoTimerProvider');
    }
    return __assign(__assign({}, context), context.state);
};
